import { OrganizationTypesEnum } from './../../enum/organization-types.enum';
import { CurrentUserService } from './../../../core/services/current-user.service';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class HeaderService {

  public metrics = [];
  public menuItems: BehaviorSubject<any> = new BehaviorSubject([]);
  public headerTitle: string = '';
  public event = new BehaviorSubject({});
  public filtering = new BehaviorSubject(false);
  public filteringEvent: boolean = false;
  public mobileActionEvent = new BehaviorSubject(this.filteringEvent);
  public showBack = new BehaviorSubject(false);
  public showActions = new BehaviorSubject(false);
  public showActionsMenu = new BehaviorSubject(false);
  public overlay = new BehaviorSubject(false);
  public additionalMenuOptions: any[] = [];
  public displayName: string;

  constructor(private _curUserService: CurrentUserService) {
   }

  public async setAdditionalMenuOptions() {
    this.additionalMenuOptions.push({ path: 'announcements', title: 'Announcements' });

    const organizationType = ((await this._curUserService.getUserInfo()) || {}).organizationType;

    if (organizationType !== OrganizationTypesEnum.CARRIER) {
      this.additionalMenuOptions.push({ path: "/contact-support", title: "Contact Support" });
    }
  }

  public async addAdditionalMenuOptions(event) {
    this.additionalMenuOptions.push(event);
  }

  public sendHeaderVisibilityEvent(status) {
    this.filtering.next(status);
  }

  public setBackVisibilityEvent(status) {
    this.showBack.next(status);
  }

  public setActionsVisibilityEvent(status) {
    this.showActions.next(status);
  }

  public setActionsMenuVisibilityEvent(status) {
    this.showActionsMenu.next(status);
  }

}
